import { useTranslation } from "react-i18next";
import type { InvoiceOptionProps } from "@/components/Navigation/GlobalHeader/GlobalSearch/types";
import { MAX_GLOBAL_SEARCH_OPTIONS } from "@/constants";
import { Icon, MenuItem } from "@trimble/modus-cmx";
import { highlightMatch } from "@/components/app/Navigation/GlobalHeader/helper";
import { format } from "@/utils/format";
import { ViewAllOption } from "../ViewAllOption/ViewAllOption";

export function InvoiceOption({
  options,
  totalCount,
  searchTerm,
  onViewAll,
}: InvoiceOptionProps) {
  const { t } = useTranslation();

  const optionsToDisplay = options.slice(0, MAX_GLOBAL_SEARCH_OPTIONS);
  return (
    <>
      {optionsToDisplay.map((option) => (
        <MenuItem key={option.invoiceId} value={option.invoiceId}>
          <div slot="start-icon" className="option">
            <Icon
              name="invoice"
              variant="solid"
              size="sm"
              decorative
              className="icon-color"
            />
            <div className="option-details">
              <span className="option-contract-number">
                {highlightMatch(option.contractNumber, searchTerm)}
              </span>
              <span
                className="option-customer-name"
                style={{ textTransform: "capitalize" }}
              >
                {highlightMatch(option.customerName.toLowerCase(), searchTerm)}
              </span>
              {option.purchaseOrderNumber ? (
                <span className="option-po-number">
                  {" "}
                  {t("global_search.contract_PO_number")}{" "}
                  {highlightMatch(option.purchaseOrderNumber, searchTerm)}
                </span>
              ) : null}
              <span className="option-customer-name">
                {format.formatDate(option.createdDate)}
              </span>
            </div>
          </div>
        </MenuItem>
      ))}
      {totalCount > MAX_GLOBAL_SEARCH_OPTIONS && (
        <ViewAllOption
          totalCount={totalCount}
          onViewAll={onViewAll}
          searchCategory="invoices"
        />
      )}
    </>
  );
}
